import React, { useState } from "react";
import "./styles.css";
import { removeWishlistItem } from "../../../../../../redux/actions/wishlist";
import { getCurrency } from "../../../../../../redux/actions/currencySelect";
import { connect } from "react-redux";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../commons/functions/generalFunctions";
import { Grid, Image, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
const { Column } = Grid;
const WishlistItem = ({
  removeWishlistItem,
  productDetails,
  currencySelect,
  getCurrency,
}) => {
  const [removing, setRemoving] = useState(false);

  const removeItemFromWishlist = () => {
    setRemoving(true);
    removeWishlistItem(productDetails.productId).then((res) =>
      setRemoving(false)
    );
  };
  return (
    <Grid columns={2}>
      <Column largeScreen={12} computer={12} tablet={12} mobile={12}>
        <Grid columns={3}>
          <Column
            largeScreen={6}
            computer={6}
            tablet={8}
            mobile={8}
            verticalAlign="middle"
          >
            <Link to={`/product/${productDetails.productId}`}>
              <Image
                src={JSON.parse(productDetails.images[0]).url}
                size="large"
                className="wishlist-item-image"
              />
            </Link>
          </Column>
          <Column
            largeScreen={7}
            computer={7}
            tablet={4}
            mobile={4}
            verticalAlign="middle"
          >
            <p className="h4 font-weight-bold">{productDetails.code}</p>
            <p className="h5">{productDetails.name}</p>
          </Column>
          <Column
            largeScreen={3}
            computer={3}
            tablet={3}
            mobile={3}
            verticalAlign="middle"
          >
            <p className="font-weight-bold">
              {currencySelect.loading
                ? "Cargando..."
                : currencySelect.currency.currency === "USD"
                ? formatterUSD.format(
                    Math.ceil(
                      productDetails.price /
                        currencySelect.currency.currencyLayer.data.value
                    ) - 0.01
                  )
                : formatCurrency(Math.ceil(productDetails.price))}
            </p>
          </Column>
        </Grid>
      </Column>

      <Column
        largeScreen={4}
        computer={4}
        tablet={6}
        mobile={6}
        verticalAlign="middle"
      >
        <Button
          icon="remove"
          size="tiny"
          content="Remover"
          onClick={removeItemFromWishlist}
          loading={removing}
        />
      </Column>
    </Grid>
  );
};

const mapStateToProps = ({ currencySelect }) => {
  return { currencySelect };
};
export default connect(mapStateToProps, { removeWishlistItem, getCurrency })(
  WishlistItem
);
